export { HorizontalBarChartComponent } from './horizontal-bar-chart.component';
export { HorizontalBarModel } from './horizontal-bar.model';
